import { render } from "./ResourceTitleList.vue?vue&type=template&id=653f9c02"
import script from "./ResourceTitleList.vue?vue&type=script&lang=js"
export * from "./ResourceTitleList.vue?vue&type=script&lang=js"

import "./ResourceTitleList.vue?vue&type=style&index=0&id=653f9c02&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__